export default __webpack_public_path__ + "static/media/mp4.d036709b.png";